import React, { PureComponent } from 'react';
import Countdown from 'Component/Countdown';
import './CmsCounter.style'


class CmsCounter extends PureComponent {
    parseDate(inputText) {
        if (!inputText || typeof inputText !== 'string') {
            return new Date();
        }

        const [datePart, timePart] = inputText.split(" ");
        const [month, day, year] = datePart.split("/");
        const [hour, minute] = timePart.split(":");
        const localDate = new Date(year, month - 1, day, hour, minute);

        return localDate;
    }

    isDaylightSavingTime(promotiondate) {
        const year = promotiondate.getFullYear();
        const lastSundayOfMarch = new Date(Date.UTC(year, 2, 31 - (new Date(year, 2, 31).getUTCDay())));
        const lastSundayOfOctober = new Date(Date.UTC(year, 9, 31 - (new Date(year, 9, 31).getUTCDay())));

        return promotiondate >= lastSundayOfMarch && promotiondate < lastSundayOfOctober;
    }

    getFormattedDate(targetDate) {
        const offsetInMilliseconds = targetDate.getTimezoneOffset() * 60 * 1000;
        const adjustedDate = new Date(targetDate.getTime() - offsetInMilliseconds);
        const timezoneOffset = this.isDaylightSavingTime(targetDate) ? ' GMT+0300' : ' GMT+0200';
        return adjustedDate.toISOString().replace(/T/g, ' ').replace(/\.\d{3}Z$/, timezoneOffset);
    }

    render() {
        const { promotiondate, textactive, textnotactive, titleactive, titlenotactive } = this.props;
        const currentDate = new Date();
        const targetDate = this.parseDate(promotiondate);
        const textToDisplay = currentDate > targetDate ? textactive : textnotactive;
        const titleToDisplay = currentDate > targetDate ? titleactive : titlenotactive;

        const formattedDate = this.getFormattedDate(targetDate);

        return (
            <div block="CmsPage" elem="Timer">
                <span block="CmsPage" elem="TimerTitle">{titleToDisplay}</span>
                <Countdown date={formattedDate} currentDate={currentDate} />
                <div block="CmsPage" elem="TimerText">{textToDisplay}</div>
            </div>
        );
    }
}

export default CmsCounter;
